var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.tianHeChildrenEnrolment
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page tianHeChildrenEnrolment-page",
            attrs: { id: "print_tianHeChildrenEnrolment" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "font-size": "23px",
                  "text-align": "center",
                  "font-weight": "600",
                  "margin-top": "50px",
                },
              },
              [
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "100%",
                      "border-collapse": "collapse",
                      border: "none",
                      "letter-spacing": "5px",
                    },
                  },
                  [
                    _c("tbody", [
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            width: "100%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.model.tianHeChildrenEnrolment.reportName
                                    ? _vm.model.tianHeChildrenEnrolment
                                        .reportName
                                    : "儿童入学健康检查表"
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "padding-left": "10px",
                  "text-align": "left",
                  width: "100%",
                  "margin-top": "30px",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "40px",
                        border: "none",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "45%",
                            border: "none",
                            "margin-top": "10px",
                          },
                          attrs: { colspan: "7" },
                        },
                        [
                          _vm._v("幼儿园："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.tianHeChildrenEnrolment.schoolName
                                  ? _vm.model.tianHeChildrenEnrolment.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "30%",
                            border: "none",
                            "margin-top": "10px",
                          },
                          attrs: { colspan: "3" },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.tianHeChildrenEnrolment.className
                                  ? _vm.model.tianHeChildrenEnrolment.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "text-align": "center",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "1px solid black",
                },
              },
              [
                _c("tbody", [
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("姓名")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.name
                                ? _vm.model.tianHeChildrenEnrolment.name
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("性别")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.sex
                                ? _vm.model.tianHeChildrenEnrolment.sex
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("年龄")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.age
                                ? _vm.model.tianHeChildrenEnrolment.age
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("出生日期")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.birthday
                                ? _vm.model.tianHeChildrenEnrolment.birthday
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("既往病史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "10" },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.tianHeChildrenEnrolment
                                  .pastMedicalHistory &&
                                _vm.model.tianHeChildrenEnrolment.pastMedicalHistory.indexOf(
                                  "2"
                                ) > -1,
                            },
                          },
                          [_vm._v("1.先天性心脏病      ")]
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.tianHeChildrenEnrolment
                                  .pastMedicalHistory &&
                                _vm.model.tianHeChildrenEnrolment.pastMedicalHistory.indexOf(
                                  "3"
                                ) > -1,
                            },
                          },
                          [_vm._v("2.癫痫      ")]
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.tianHeChildrenEnrolment
                                  .pastMedicalHistory &&
                                _vm.model.tianHeChildrenEnrolment.pastMedicalHistory.indexOf(
                                  "4"
                                ) > -1,
                            },
                          },
                          [_vm._v("3.高热惊厥      ")]
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.tianHeChildrenEnrolment
                                  .pastMedicalHistory &&
                                _vm.model.tianHeChildrenEnrolment.pastMedicalHistory.indexOf(
                                  "5"
                                ) > -1,
                            },
                          },
                          [_vm._v("4.哮喘      ")]
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.tianHeChildrenEnrolment
                                  .pastMedicalHistory &&
                                _vm.model.tianHeChildrenEnrolment.pastMedicalHistory.indexOf(
                                  "7"
                                ) > -1,
                            },
                          },
                          [_vm._v("5.其他      ")]
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.tianHeChildrenEnrolment
                                  .pastMedicalHistory &&
                                _vm.model.tianHeChildrenEnrolment.pastMedicalHistory.indexOf(
                                  "1"
                                ) > -1,
                            },
                          },
                          [_vm._v("6.无")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("过敏史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.allergyHistory
                                ? _vm.model.tianHeChildrenEnrolment
                                    .allergyHistory
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("儿童家长确认签名")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment
                                .parentConfirmSignature
                                ? _vm.model.tianHeChildrenEnrolment
                                    .parentConfirmSignature
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "writing-mode": "vertical-rl",
                          "text-orientation": "upright",
                          "letter-spacing": "15px",
                        },
                        attrs: { rowspan: "5" },
                      },
                      [_vm._v("体格检查")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("体重")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.weight
                                ? _vm.model.tianHeChildrenEnrolment.weight
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("kg")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("评价")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.weightAssessment
                                ? _vm.model.tianHeChildrenEnrolment
                                    .weightAssessment
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("身长(高)")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.height
                                ? _vm.model.tianHeChildrenEnrolment.height
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("cm")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("评价")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.heightAssessment
                                ? _vm.model.tianHeChildrenEnrolment
                                    .heightAssessment
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("皮肤")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.skin
                                ? _vm.model.tianHeChildrenEnrolment.skin
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("眼")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "5px",
                            },
                          },
                          [_vm._v("左")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.leftEye
                                ? _vm.model.tianHeChildrenEnrolment.leftEye
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("视力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "5px",
                            },
                          },
                          [_vm._v("左")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.leftEyeVision
                                ? _vm.model.tianHeChildrenEnrolment
                                    .leftEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("耳")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "5px",
                            },
                          },
                          [_vm._v("左")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.leftEar
                                ? _vm.model.tianHeChildrenEnrolment.leftEar
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("口腔")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("牙齿数")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.numberTeeth !=
                                null ||
                                _vm.model.tianHeChildrenEnrolment.numberTeeth ==
                                  0
                                ? _vm.model.tianHeChildrenEnrolment.numberTeeth
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "5px",
                            },
                          },
                          [_vm._v("右")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.rightEye
                                ? _vm.model.tianHeChildrenEnrolment.rightEye
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "5px",
                            },
                          },
                          [_vm._v("右")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.rightEyeVision
                                ? _vm.model.tianHeChildrenEnrolment
                                    .rightEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "5px",
                            },
                          },
                          [_vm._v("右")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.rightEar
                                ? _vm.model.tianHeChildrenEnrolment.rightEar
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("龋齿数")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment
                                .cariesTotalNumber != null ||
                                _vm.model.tianHeChildrenEnrolment
                                  .cariesTotalNumber == 0
                                ? _vm.model.tianHeChildrenEnrolment
                                    .cariesTotalNumber
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("头颅")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.head
                                ? _vm.model.tianHeChildrenEnrolment.head
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("胸廓")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.thorax
                                ? _vm.model.tianHeChildrenEnrolment.thorax
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("脊柱四肢")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.spinalAppendages
                                ? _vm.model.tianHeChildrenEnrolment
                                    .spinalAppendages
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("咽部")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.pharynx
                                ? _vm.model.tianHeChildrenEnrolment.pharynx
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("心肺")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.heart
                                ? _vm.model.tianHeChildrenEnrolment.heart
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肝脾")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.liverAndSpleen
                                ? _vm.model.tianHeChildrenEnrolment
                                    .liverAndSpleen
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("外生殖器")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment
                                .maleExternalGenitalia
                                ? _vm.model.tianHeChildrenEnrolment
                                    .maleExternalGenitalia
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment
                                .otherPhysicalExamination
                                ? _vm.model.tianHeChildrenEnrolment
                                    .otherPhysicalExamination
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "writing-mode": "vertical-rl",
                          "text-orientation": "upright",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("辅助检查")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("血红蛋白(Hb)")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.hemoglobinValue
                                ? _vm.model.tianHeChildrenEnrolment
                                    .hemoglobinValue
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("g/L")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("丙氨酸氨基转移酶")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment
                                .alanineAminotransferase
                                ? _vm.model.tianHeChildrenEnrolment
                                    .alanineAminotransferase
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("u/L")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          padding: "8px 12px",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "8" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment
                                .otherAuxiliaryInspection
                                ? _vm.model.tianHeChildrenEnrolment
                                    .otherAuxiliaryInspection
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "70px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("检查结果")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          padding: "8px 12px",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.examineResult
                                ? _vm.model.tianHeChildrenEnrolment
                                    .examineResult
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "1" },
                      },
                      [_vm._v("医生意见")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          padding: "8px 12px",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.doctorOpinion
                                ? _vm.model.tianHeChildrenEnrolment
                                    .doctorOpinion
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "padding-top": "60px",
                          "text-align": "right",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("医生签名：")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "padding-top": "60px",
                          "text-align": "right",
                        },
                        attrs: { colspan: "1" },
                      },
                      [
                        _vm.model.tianHeChildrenEnrolment.doctorSignature
                          ? _c("img", {
                              staticStyle: {
                                height: "40px",
                                width: "100px",
                                "object-fit": "contain",
                              },
                              attrs: {
                                src: _vm.model.tianHeChildrenEnrolment
                                  .doctorSignature,
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "padding-top": "60px",
                          "text-align": "right",
                        },
                        attrs: { colspan: "3" },
                      },
                      [_vm._v("检查单位：")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "padding-top": "60px",
                          "text-align": "left",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.hospitalName
                                ? _vm.model.tianHeChildrenEnrolment.hospitalName
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "padding-bottom": "60px",
                          "text-align": "right",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("体检日期：")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "padding-bottom": "60px",
                          "text-align": "left",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.tianHeChildrenEnrolment.physicalDate
                                ? _vm.model.tianHeChildrenEnrolment.physicalDate
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: { "padding-bottom": "60px" },
                        attrs: { colspan: "8" },
                      },
                      [_vm._v("（检查单位盖章）")]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }